import React from "react";
import { Link } from "@reach/router";
import { ReactSVG } from "react-svg";
import { useEnvContext } from "@gw/env-context";
import { AnchorButton, AnchorLink } from "@gw/component-library";
import { useBNIdentity } from "@gw/bn-identity";
import { imgs } from "@gw/theming";
import { HeaderStyled, LogoContainer } from "./HeaderStyled";
import { useTheme } from "styled-components";
var configured = false;
var Header = function () {
    var imgsFolder = useEnvContext().imgsFolder;
    var gwThemed = useTheme().gwThemed;
    var _a = useBNIdentity(), isAdmin = _a.isAdmin, isUser = _a.isUser, logout = _a.logout, user = _a.user;
    if (user && !configured) {
        if (process.env.REACT_APP_GA3) {
            window.gtag("config", process.env.REACT_APP_GA2, {
                user_id: user.email,
            });
        }
        if (process.env.REACT_APP_GA3) {
            window.gtag("config", process.env.REACT_APP_GA3, {
                user_id: user.email,
            });
        }
        configured = true;
    }
    return (React.createElement(HeaderStyled, null,
        React.createElement(LogoContainer, null,
            React.createElement(Link, { to: "/directory" },
                React.createElement(ReactSVG, { className: "logoIcon", src: imgsFolder + "/" + gwThemed.logo, alt: "GreenWave Logo" }),
                React.createElement(ReactSVG, { className: "logoIconStacked", src: imgsFolder + "/" + gwThemed.logoStacked, alt: "GreenWave Logo" })),
            React.createElement("div", { className: "title-container" },
                React.createElement("h1", null, "Seaweed Source"),
                React.createElement("h2", null, "Connecting Buyers and Farmers"))),
        user && (React.createElement("div", { className: "nav-container" },
            React.createElement(AnchorLink, { to: isAdmin()
                    ? "/admin/users"
                    : isUser() && !isAdmin()
                        ? "/profile"
                        : "#" },
                React.createElement(ReactSVG, { src: imgsFolder + "/" + imgs.icons.placeholderAvatar, alt: "user profile" })),
            React.createElement(AnchorLink, { className: "profile-link", to: isAdmin()
                    ? "/admin/users"
                    : isUser() && !isAdmin()
                        ? "/profile"
                        : "#" }, (user && user.first_name) + " " + (user && user.last_name)),
            isUser() ? (React.createElement(React.Fragment, null,
                React.createElement(AnchorButton, { onClick: function () {
                        logout();
                    } },
                    React.createElement(ReactSVG, { className: "logoutIcon", src: imgsFolder + "/" + imgs.icons.iconLogOut })))) : (React.createElement(React.Fragment, null))))));
};
export default Header;
//# sourceMappingURL=Header.js.map